import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {TechSignInComponent} from "./components/sign-in/tech-sign-in.component";

const routes: Routes = [
  {
    path: 'sign-in',
    component: TechSignInComponent
  },
  {
    path: '**',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
